<template>
  <div class="list product">
    <div style="font-size: 24px;background-color: #f5f5f5;padding: 10px;">{{type==0?'添加商品':'编辑商品'}}</div>
	
	<div class="item">
		<span>名称：</span>
		<el-input v-model="data.title" clearable placeholder="请输入内容"></el-input>
	</div>
	<div class="item">
		<span>价格：</span>
		<el-input v-model="data.price" clearable placeholder="请输入内容"></el-input>
	</div>
	<div class="item">
		<span>库存：</span>
		<el-input v-model="data.stock" clearable placeholder="请输入内容"></el-input>
	</div>
	<div class="item">
		<span>销量：</span>
		<el-input v-model="data.sale_count" clearable placeholder="请输入内容"></el-input>
	</div>
	<div class="item">
		<span>所属商家：</span>
		<el-select v-model="data.shop_no" @change="shopChange" filterable clearable placeholder="请选择">
		    <el-option
		      v-for="item in shopOptions"
		      :key="item.user_no"
		      :label="item.name"
		      :value="item.user_no">
		    </el-option>
		</el-select>
	</div>
	<div class="item">
		<span>商品类别：</span>
		<el-select v-model="data.category_id" clearable filterable placeholder="请选择">
		    <el-option
		      v-for="item in labelOptions"
		      :key="item.relation_one"
		      :label="item.description"
		      :value="item.relation_one">
		    </el-option>
		</el-select>
	</div>
	<div class="item itemTwo">
		<span>展示图：</span>
		<div class="upload">
			<component
			  :defaultValue="data.mainImg"
			  is="upload"
			  @onChange="imageChange"
			>
			</component>
		</div>
	</div>
	<div class="item itemTwo">
		<span>轮播图：</span>
		<div class="upload">
			<component
			  :defaultValue="data.bannerImg"
			  is="upload"
			  @onChange="imageChange2"
			>
			</component>
		</div>
	</div>
	<div class="item itemTwo">
		<span>详情描述：</span>
		<el-input
		  type="textarea"
		  :autosize="{ minRows: 3, maxRows: 5}"
		  placeholder="请输入内容"
		  v-model="data.content">
		</el-input>
	</div>
	<div class="item itemTwo">
		<span>详情展示图：</span>
		<div class="upload">
			<component
			  :defaultValue="data.img_array"
			  is="upload"
			  @onChange="imageChange3"
			>
			</component>
		</div>
	</div>
	<div class="itemBtn">
		<el-button type="primary" v-if="type==0" @click="addProduct">添加</el-button>
		<el-button type="primary" v-else @click="updateProduct">确认</el-button>
	</div>
	
  </div>
</template>


<script>
  import productdetailJs from './productdetail.js'
  export default productdetailJs
</script>
<style>


</style>
<style scoped="scoped">
	.product{text-align: left;overflow-y: auto;}
	.product .el-input{width: 60%;}
	.product .item{padding-top: 30px;display: inline-block;width: 48%;}
	.product .itemTwo{width: 100%;}
	.product .item span{font-size: 16px;display: inline-block;width: 100px;text-align: right;}
	.product .item input{height: 30px;line-height: 30px;padding: 0;}
	.product .upload{width: 29%;display: inline-block;}
	.product .el-textarea{width: 60%;}
	.product .itemBtn{padding: 40px 0 100px 100px;}
	.product .el-button{width: 180px;}
</style>


// WEBPACK FOOTER //
// src/views/detail/productdetail.vue